/**
 * VG product card — intensity bar reveal on grids (collection, search, recommendations).
 * Bestsellers carousel keeps its own init in bestsellers-new.js.
 */
(function () {
  'use strict';

  function initIntensityBars(root) {
    root = root || document;
    var bars = root.querySelectorAll('.vg-intensity-bar:not(.is-inview)');
    if (!bars.length) return;

    if (
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      typeof IntersectionObserver === 'undefined'
    ) {
      bars.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '-40px 0px', threshold: 0 }
    );

    bars.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initJudgeMeBadges() {
    if (typeof window.jdgm === 'undefined') return;
    if (typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  }

  function onReady() {
    initIntensityBars(document);
    initJudgeMeBadges();
    window.setTimeout(initJudgeMeBadges, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initIntensityBars(evt.target);
    initJudgeMeBadges();
  });
})();
